import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CountUp from 'react-countup';
import { IconButton, Icon, ClickAwayListener } from '@material-ui/core';

import { Tooltip } from '../../../../../components';

const images = require.context('../../../../../../images/reportingIcons', true);

const styles = {
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 2fr',
  },
  icon: {
    padding: '25px',
    textAlign: 'center',
  },
  image: {
    verticalAlign: 'middle',
    width: '40px',
  },
  imagePlaceholder: {
    background: '#fefefe',
  },
  content: {
    background: '#fefefe',
    textAlign: 'right',
    height: '90px',
    padding: '5px 10px',
    position: 'relative',
  },
  title: {
    display: 'inline',
    fontSize: '14px',
    fontWeight: '200',
    color: '#909090',
    margin: '6px 0',
  },
  titleComparision: {
    display: 'inline',
    fontSize: '14px',
    fontWeight: '200',
    color: '#909090',
    margin: '0px',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  titleButton: {
    padding: '0',
    marginLeft: '5px',
  },
  main: {
    fontSize: '34px',
    fontWeight: 400,
  },
  comparisonValues: {
    margin: '0px',
    color: '#666666',
  },
  overlay: {
    backgroundColor: 'rgba(255,255,255,0.8)',
    position: 'absolute',
    zIndex: 2000,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    padding: '5px 15px',
    textAlign: 'left',
  },
};

class KeyFigure extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlayVisible: false,
    };
  }

  toggleOverlay = () => {
    const { overlayVisible } = this.state;

    this.setState({
      overlayVisible: !overlayVisible,
    });
  }

  hideOverlay = () => {
    this.setState({
      overlayVisible: false,
    });
  }

  handleClick = () => {
    const { linkedReport, selectReport } = this.props;

    if (linkedReport) {
      selectReport(linkedReport.reportID);
    }
  }

  render() {
    const {
      keyFigure, linkedReport, hideIcon, index,
    } = this.props;
    const { overlayVisible } = this.state;

    const icon = {
      ...styles.icon,
      background: keyFigure.color,
    };

    const image = keyFigure.image ? images(`./${keyFigure.image}`).default : null;
    const hasComparision = keyFigure.comparisonValues?.length > 0;

    const comparison = keyFigure.comparisonValues?.map((cv, i) => {
      if (keyFigure.isText) {
        return (
          // eslint-disable-next-line react/no-array-index-key
          <span key={i}>
            {cv}
          </span>
        );
      }

      const trendNumber = (100 - (keyFigure.keyFigure / cv * 100)) * -1;
      let trend = null;

      if (!Number.isNaN(trendNumber) && Number.isFinite(trendNumber) && trendNumber !== 0) {
        trend = <CountUp end={trendNumber} suffix="%" className={trendNumber > 0 ? 'positive' : 'negative'} />;
      } else {
        trend = '-';
      }

      return (
        // eslint-disable-next-line react/no-array-index-key
        <span key={i}>
          <CountUp end={cv} suffix={keyFigure.unit} />
          {' ('}
          {trend}
          {') '}
        </span>
      );
    });

    return (
      <Tooltip title={linkedReport ? `Zum ${linkedReport.name}-Bericht` : null}>
        <div
          key={keyFigure.title}
          style={styles.row}
          onClick={this.handleClick}
          onKeyDown={this.handleClick}
          className={linkedReport ? 'key-figure pointer' : 'key-figure'}
        >
          {!hideIcon ? (
            <div style={icon} className={`key-figure-icon background-shade-${index}`}>
              <img src={image} alt={keyFigure.image} style={styles.image} />
            </div>
          ) : <div style={styles.imagePlaceholder} />}
          <div style={styles.content}>
            <div style={styles.titleContainer}>
              <h4 style={hasComparision ? styles.titleComparision : styles.title}>{keyFigure.title}</h4>
              {keyFigure.description && (
              <IconButton style={styles.titleButton} onClick={this.toggleOverlay}>
                <Icon fontSize="small">help</Icon>
              </IconButton>
              )}
            </div>
            {overlayVisible
              && (
              <ClickAwayListener onClickAway={this.hideOverlay}>
                <div style={styles.overlay} onClick={this.hideOverlay} onKeyDown={this.hideOverlay}>
                  {keyFigure.description}
                </div>
              </ClickAwayListener>
              )}
            <span style={styles.main}>
              {keyFigure.isText
                ? keyFigure.keyFigure : (
                  <CountUp
                    separator=" "
                    end={keyFigure.keyFigure}
                    suffix={keyFigure.unit}
                    {...keyFigure}
                  />
                )
              }

            </span>
            <p style={styles.comparisonValues}>
              {comparison}
            </p>
          </div>
        </div>
      </Tooltip>
    );
  }
}

KeyFigure.propTypes = {
  keyFigure: PropTypes.object.isRequired,
  linkedReport: PropTypes.object,
  selectReport: PropTypes.func.isRequired,
  hideIcon: PropTypes.bool,
  index: PropTypes.number,
};

KeyFigure.defaultProps = {
  linkedReport: null,
  hideIcon: false,
  index: 0,
};

export default KeyFigure;
